import { Injectable } from '@angular/core';
import { Config, OccConfig } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
  useExisting: Config,
})
export abstract class CheckoutConfig extends OccConfig {
  checkout?: {
    /**
     * Specify the time in seconds to wait between processing checks
     */
    processingInterval: number;
    /**
     * Specify the time in seconds to delay before transitioning to cart
     */
    cartDelay: number;
    /**
     * Specify the time in seconds to wait between order details checks
     */
    orderDetailsInterval: number;
    /**
     * Specify the number of attempts of getting order details before giving up
     */
    orderDetailsAttempts: number;
  };
}
